/**
 * IGRA-411 — кабинет сообщает бэкенду часовой пояс человека.
 *
 * Зачем: журнал звёзд пишет часы по серверу (UTC), а награда «Ночная смена»
 * даётся за ночь ЧЕЛОВЕКА. Пояс знает только браузер, взяться ему больше
 * неоткуда — начисления приходят от крона.
 *
 * Пока пояс не сообщён, награда не выдаётся вовсе (решение оператора), поэтому
 * отправка идёт при входе в кабинет, а не на странице настроек, куда человек
 * может не зайти никогда.
 */
import { httpClient } from '@/shared/api/httpClient'

/** Что уже отправляли: второй раз то же самое слать незачем. */
const SENT_KEY = 'igra_tz_sent'

function currentZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || ''
  } catch {
    return ''
  }
}

/**
 * Отправить пояс, если он изменился с прошлого раза.
 *
 * Память о последней отправке — в `localStorage`, ровно как подсказка для
 * самого браузера: она экономит запрос, но её потеря ничего не ломает, худшее
 * последствие — лишний POST на одну загрузку. Поэтому любой отказ storage
 * глушится: из-за приватного окна кабинет падать не должен.
 *
 * Ошибка сети тоже глушится — пояс не то, ради чего стоит показывать человеку
 * сообщение об ошибке. Не дошло сейчас, дойдёт при следующем заходе.
 */
export async function reportTimezone(): Promise<void> {
  const timezone = currentZone()
  if (!timezone) return

  let remembered: string | null = null
  try {
    remembered = localStorage.getItem(SENT_KEY)
  } catch {
    remembered = null
  }
  if (remembered === timezone) return

  try {
    await httpClient.post('/vpn/timezone', { timezone })
    try {
      localStorage.setItem(SENT_KEY, timezone)
    } catch {
      // Приватное окно: отправим ещё раз в следующий заход, и это нормально.
    }
  } catch {
    // Молча: пояс догонит на следующей загрузке кабинета.
  }
}
